<template>
<div>
    <NavSection />
    <section class="storefront-hero-section">
        <div class="sf_hero-wrap">
            <div class="sf_hero-div">
                <div class="sf_heroleft">
                    <div class="text-block-860">This is some text inside of a div block.</div>
                    <div class="text-block-861">This is some text inside of a div block.</div>
                    <router-link :to="{  name: 'OnboardingQuestions'}" class="button-86 w-button">TAKE THE QUIZ</router-link>
                </div>
                <div class="store-top-image-div"><img src="@/assets/webp/StoreTopImage.webp" loading="lazy" sizes="(max-width: 479px) 94vw, 34vw" srcset="@/assets/webp/StoreTopImage-p-500.webp 500w, @/assets/webp/StoreTopImage-p-800.webp 800w, @/assets/webp/StoreTopImage-p-1080.webp 1080w, @/assets/webp/StoreTopImage.webp 1374w" alt=""></div>
            </div>
        </div>
    </section>
    <categoryNav :categories="categories"></categoryNav>
    <section class="shop-section storefront " :class="{'first-item' : index===0}" v-for="(cat , index) in categories" :key="`catdetails-${index}`">
        <div class="shop-div-wrap storefront">
            <div :id="cat" class="spacer-for-page-linking"></div>
            <div class="shop-div">
                <div class="shop-header-div">
                    <div class="category-section-header-div">
                        <div class="category-headers">{{cat}}</div>
                        <div :class="`category-color-dot ${cat.toLowerCase()}`"></div>
                    </div>
                    <div class="text-block-776">{{ categoryDescriptions[cat] }}</div>
                </div>
                <div class="row-header-div">
                    <div class="row-header">Online Prescriptions</div>
                    <img src="@/assets/images/icon_-RX-black.svg" loading="lazy" alt="" class="image-402">
                </div>
                <ProductSlider :products="loadProducts(cat,1)" :category="cat" />
                <div class="row-header-div" v-if="loadProducts(cat,0).length">
                    <div class="row-header">Clinical Supplements</div>
                </div>
                <ProductSlider :products="loadProducts(cat,0)" :category="cat" />
            </div>
        </div>
    </section>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import ProductSlider from './ProductSlider.vue';
import NavSection from '../product/NavSection.vue';
import categoryNav from './CategoryNav.vue'
import {
    getProductsByCategory
} from '@/utils/productData';

export default {
    name: 'ShopPage',

    components: {
        ProductSlider,
        NavSection,
        categoryNav
    },

    data() {
        return {
            selectedCategory: null,
            categories: [
                "Weight",
                "Mind",
                "Longevity",
                "Body",
                "Hair",
                "Skin",
                "Sex"
            ],
            categoryDescriptions: {
                'Weight': 'Prescription and clinical-grade supplements to help you lose weight with less effort.',
                'Mind': 'Enhance cognitive function and mental clarity with proven solutions.',
                'Longevity': 'Support healthy aging and vitality with cutting-edge treatments.',
                'Sex': 'Balance and optimize your hormone levels naturally.',
                'Hair': 'Promote hair growth and prevent hair loss with proven treatments.',
                'Skin': 'Rejuvenate and maintain healthy, youthful-looking skin.',
                'Body': 'Rejuvenate and maintain healthy, youthful-looking skin.',
            },
            allProducts: []
        };
    },

    computed: {
        ...mapGetters([
            'cartItems',
            'cartItemCount',
            'isCartOpen'
        ]),

        displayedProducts() {
            if (!this.selectedCategory) {
                return this.allProducts;
            }

            return this.allProducts.filter(product => {
                const productCategory = product?.category?.toUpperCase();
                const productCategory1 = product?.category_1?.toUpperCase();
                const productCategory2 = product?.category_2?.toUpperCase();
                const targetCategory = this.selectedCategory.toUpperCase();

                return productCategory === targetCategory ||
                    productCategory1 === targetCategory ||
                    productCategory2 === targetCategory;
            });
        }
    },

    methods: {
        handleAddToCart(cartItem) {
            console.log(JSON.stringify(cartItem))

            this.$emit('add-to-cart', cartItem);

        },

        loadProducts(category, type) {
            try {
                const productsSet = new Set();
                const categoryProducts = getProductsByCategory(category, type) || [];

                categoryProducts.forEach(product => {
                    if (product?.sku) {
                        productsSet.add(JSON.stringify(product));
                    }
                });

                // Convert back to array and parse JSON
                return Array.from(productsSet)
                    .map(productString => JSON.parse(productString))
                    .sort((a, b) => {
                        // Handle missing product_name gracefully
                        const nameA = a.product_name || "";
                        const nameB = b.product_name || "";
                        return nameA.localeCompare(nameB);
                    });
            } catch (error) {
                console.error('Error loading products:', error);
                return [];
            }
        },
    },
    watch: {
        selectedCategory(newCategory) {
            console.log('Category changed:', newCategory || 'ALL');
            console.log('Displayed products:', this.displayedProducts.length);
        }
    },

    async created() {

    }
};
</script>

<style scoped>
.first-item{
        padding-top: 50px !important;
    }
    @media screen and (max-width: 479px) {
        .spacer-for-page-linking {
            height: 12px !important;
        }
        
    }
</style>
